module.exports = __webpack_public_path__ + "img/elephant.2e2250b7.png";